import {ChangeEvent, FC, useState, useRef, useEffect} from 'react'
import {KTCard} from '../../../../../../_metronic/helpers'
import {Button} from '../../Button'
import {ModalErrorTable, ModalErrorList} from '../../Modal'
import {TableResumen} from '../../../../features/central/model'
import {ShowSnackBar} from '../../../../util/functions'
import Poppup from '../../Poppup'
import {
  getLoadMasiveId,
  getLoadPercentage,
} from '../../../../features/central/services/bulkload.service'
import {getSnackBarToast} from '../../../../util/snackBar'

interface Props {
  serviceTemplate?: () => void
  handleSendService?: (data: any, bulkLoadId: string) => Promise<any>
  textData?: string
  textData1?: string
  showModalList?: boolean
  title?: string
  fileNameDownload?: string | null
}
const FormMasiveBulk: FC<Props> = ({
  serviceTemplate = () => {},
  handleSendService = async () => {},
  textData1 = '',
  textData = '',
  showModalList = false,
  title = '',
  fileNameDownload,
}) => {
  const [file, setFile] = useState<File | null>(null)
  const [fileName, setFileName] = useState<File | null>(null)
  const [error, setError] = useState('')
  const [show, setShow] = useState(false)
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<TableResumen[] | any>([])
  const [response1, setResponse1] = useState<TableResumen[] | any>([])
  const [progress, setProgress] = useState(0)
  const [titleUpload, setTitleUpload] = useState('')
  const [showPoppup, setShowPoppup] = useState(false)
  const [text, setText] = useState<TableResumen[] | any>([])
  const [errorText, setErrorText] = useState<string>('')
  const [loadingDownload, setLoadingDownload] = useState(false)
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const completeIntervalRef = useRef<number | null>(null)

  const handleGetTemplate = async () => {
    try {
      setLoadingDownload(true)
      const response = (await serviceTemplate()) as any
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = fileNameDownload ? `${fileNameDownload}.xlsx` : `${title}-Plantilla.xlsx` // Ajusta el nombre del archivo según tus necesidades
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setLoadingDownload(false)
    } catch (error) {
      ShowSnackBar('Hubo un error', 'error')
    }
  }
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0]
    setFile(selectedFile || null)
    setFileName(selectedFile || null)
    setError('')
    setProgress(0)
  }

  const handleUpload = async () => {
    try {
      if (file) {
        const originalName = file.name
        const ext = originalName.substring(originalName.lastIndexOf('.'))
        const base = originalName.substring(0, originalName.lastIndexOf('.'))

        const newBase = base.substring(0, 40) // cortar a 50
        const newName = `${newBase}${ext}` // nombre final con extensión

        // Crear nuevo archivo
        const newFile = new File([file], newName, {type: file.type})
        const formData = new FormData()
        formData.append('test', newFile)
        setLoading(true)
        setShowPoppup(true)
        setTitleUpload('Cargando archivo...')
        const respId = await getLoadMasiveId()
        if (!respId.data.error) {
          const bulkLoadId = respId?.data?.BulkLoadId
          handleSendService(formData, bulkLoadId) // Use the service to upload the file
          completeIntervalRef.current = window.setInterval(async () => {
            const response2 = await getLoadPercentage(bulkLoadId)
            if (response2.data.error) {
              setLoading(false)
              clearInterval(completeIntervalRef.current!)
              setShowPoppup(false)
              setShow(true)
              const errorResponse = JSON.parse(response2?.data?.MsgError || '{}')
              const error = errorResponse?.data || []
              const error1 = errorResponse?.data1 || []
              const message = errorResponse?.message || ''
              setText(message)
              setResponse(error)
              setResponse1(error1)
              setErrorText(message)
            } else {
              if (
                response2.data.Paso2_Porcentaje === 100 &&
                response2.data.Paso1_Porcentaje === 100
              ) {
                clearInterval(completeIntervalRef.current!)
                setLoading(false)
                setShowPoppup(false)
                getSnackBarToast(
                  'Documento cargado correctamente, ingrese a la bandeja si tiene observaciones',
                  'success',
                )
              } else {
                if (response2.data.Paso1_Porcentaje === 100) {
                  const pr2 = response2.data.Paso2_Porcentaje
                  setTitleUpload(
                    'Se está cargando la información, espere un momento mientras termine de procesar ...',
                  )
                  setProgress(pr2)
                } else {
                  if (
                    response2?.data?.Paso1_Porcentaje !== null &&
                    response2?.data?.Paso1_Porcentaje !== undefined
                  ) {
                    const pr = response2.data.Paso1_Porcentaje
                    setTitleUpload('Se estan validando los datos del archivo...')
                    setProgress(pr)
                  } else {
                    clearInterval(completeIntervalRef.current!)
                    ShowSnackBar('Hubo un error', 'error')
                    setLoading(false)
                    setShowPoppup(false)
                    setFile(null)
                    setProgress(0)
                  }
                }
              }
            }
          }, 2000)
        } else {
          setLoading(false)
          setShowPoppup(false)
          setProgress(0)
          setFile(null)
          const message = respId.data.message || 'Hubo un error'
          getSnackBarToast(message, 'error')
        }
        if (fileInputRef.current) {
          fileInputRef.current.value = ''
        }
        // Iniciar el incremento final hasta 100%
        setFile(null)
      } else {
        setError('Este campo es requerido')
      }
    } catch (error) {
      ShowSnackBar('Hubo un error', 'error')
      setLoading(false)
      setShowPoppup(false)
      setFile(null)
      setProgress(0)
    }
  }
  const handleClosePoppup = () => {
    if (completeIntervalRef.current !== null) {
      clearInterval(completeIntervalRef.current)
      completeIntervalRef.current = null
    }
    setFile(null)
    setShowPoppup(false)
    setLoading(false)
  }
  return (
    <KTCard shadow className='m-5'>
      <form>
        <div className='p-6'>
          <div className='row'>
            <div className='mb-12 col-sm-12 col-lg-12'>
              <Button
                onClick={handleGetTemplate}
                label='Descargar Plantilla'
                loading={loadingDownload}
              />
            </div>
            <div className='mb-2 col-sm-12 col-md-6 col-lg-4'>
              <label className='required form-label'>Examinar</label>
              <div className='input-group input-group-sm'>
                <input
                  className='form-control'
                  type='file'
                  id='formFileRoom'
                  onChange={handleFileChange}
                  ref={fileInputRef}
                />
              </div>
              {showPoppup && (
                <Poppup
                  progress={progress}
                  handleClose={handleClosePoppup}
                  text={titleUpload}
                  hasClose
                />
              )}

              {error && <p className='error-message'>{error?.toString()}</p>}
            </div>
          </div>
        </div>
        <div className='d-flex justify-content-center mb-3'>
          <Button onClick={handleUpload} label='Subir Archivo' disabled={loading} />
        </div>
      </form>
      {showModalList ? (
        <ModalErrorList show={show} setShow={setShow} file={file} message={errorText} />
      ) : (
        <ModalErrorTable
          show={show}
          setShow={setShow}
          data={response}
          file={fileName}
          message={text}
          data1={response1}
          textData1={textData1}
          textData={textData}
          size='xl'
        />
      )}
    </KTCard>
  )
}

export {FormMasiveBulk}
